import gql from 'graphql-tag';

export default gql`
  fragment LoyaltyPaymentFragment on LoyaltyPayment {
    id
    points
  }
`;
